import { Query } from '@apollo/client/react/components';
import RequestToJoinCheckbox, { SetRequestToJoinMutationFn } from './RequestToJoinCheckbox';
import React from 'react';
import GROUP_MEMBERSHIP_REQUESTS_COUNT_QUERY from 'groupMembershipRequests/containers/queries/GroupMembershipRequestsCountQuery.gql';
import type {
  GroupMembershipRequestsCountQuery,
  GroupMembershipRequestsCountQueryVariables,
} from 'groupMembershipRequests/containers/queries/__generated__/GroupMembershipRequestsCountQuery';
import { isNil } from 'lodash';
import { mountModal } from 'lib/modal';
import ConfirmDialog from 'components/ConfirmDialog';

const renderDisableRequestToJoinModal = (count: number, onConfirm: () => void) => {
  return (
    <ConfirmDialog
      title="Approve pending requests?"
      subtext={`There are currently ${count} pending requests to join this class. By unchecking this box, do you want to approve their requests?`}
      cancelButtonText="Cancel"
      actionButtonText={`Approve ${count} pending requests`}
      onConfirm={onConfirm}
    />
  );
};

const RequestToJoinContainer = ({
  requestToJoinFromBackend,
  requestToJoinEnabledRecommendation,
  requestToJoinFromFrontend,
  groupUuid,
  setRequestToJoinEnabled,
  disabled,
}: {
  requestToJoinFromBackend?: boolean | null;
  requestToJoinEnabledRecommendation: string;
  requestToJoinFromFrontend?: boolean | null;
  groupUuid: string | null | undefined;
  setRequestToJoinEnabled: (enabled: boolean) => void;
  disabled: boolean;
}) => {
  const requestToJoinEnabled: boolean = (
    isNil(requestToJoinFromFrontend) ? requestToJoinFromBackend : requestToJoinFromFrontend
  ) as boolean;

  return (
    <Query<GroupMembershipRequestsCountQuery, GroupMembershipRequestsCountQueryVariables>
      query={GROUP_MEMBERSHIP_REQUESTS_COUNT_QUERY}
      variables={{ groupUuid: groupUuid || '' }}
      fetchPolicy="network-only"
      skip={!requestToJoinEnabled || !groupUuid}
    >
      {({ data }) => {
        const requestCount = data?.classes?.[0]?.groupMembershipRequestsCount ?? 0;
        return (
          <RequestToJoinCheckbox
            disabled={disabled}
            checked={requestToJoinEnabled}
            requestToJoinEnabledRecommendation={requestToJoinEnabledRecommendation}
            onChange={(e, requestToJoinMutation: SetRequestToJoinMutationFn) => {
              const enabled = e.target.checked;
              const toggleRequestToJoin = () => {
                if (groupUuid) {
                  requestToJoinMutation({ variables: { input: { groupUuid, enabled } } });
                }
                setRequestToJoinEnabled(enabled);
              };

              if (requestToJoinEnabled && requestCount > 0) {
                mountModal(renderDisableRequestToJoinModal(requestCount, toggleRequestToJoin));
              } else {
                toggleRequestToJoin();
              }
            }}
          />
        );
      }}
    </Query>
  );
};

export default RequestToJoinContainer;
